import { gql } from '@apollo/client';

export const FETCH_GOAL_NAME = gql`
  query fetchGoalName($id: ObjectID!) {
    fetchGoal(goalId: $id) {
      goal {
        type
        name
      }
    }
  }
`;
